import StdButton from "../../components/StdButton";

export default function GroupButton({ label, onClick, color = null }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row-reverse",
        margin: 10,
      }}
    >
      <StdButton
        label={label}
        onClick={onClick}
        color={color}
        style={{ minWidth: 30 }}
      />
    </div>
  );
}
